export default __webpack_public_path__ + "static/media/jalaponia.53218238.jpeg";